<!-- FIN-0106: Circle-First Design Language - Stadium input, circular send button, 120Hz optimized -->
<!-- FIN-0108: Dark mode uses elevated surface for input, desaturated brand for send button -->
<div class="w-full px-3 sm:px-4 md:px-6 lg:px-8 xl:px-16 pt-3 pb-3 z-50 overflow-x-hidden sticky bottom-0 bg-linear-to-t from-white via-white to-white/95 dark:from-dark-base dark:via-dark-base dark:to-dark-base/95 pb-[calc(0.75rem+env(safe-area-inset-bottom))]">
  <div class="content max-w-4xl mx-auto">
    <!-- FIN-0105: Flexbox siblings (no absolute positioning) - most reliable cross-browser centering -->
    <!-- Stadium/pill container with textarea and button as flex siblings -->
    <div class="flex items-center gap-1.5 rounded-[1.25rem] overflow-hidden py-1.5 pl-3 pr-1.5 transition-all duration-fast ease-smooth-out"
         [ngClass]="canSend ? 'bg-gray-100 dark:bg-dark-elevated' : 'bg-gray-50 dark:bg-dark-elevated/50'">
      <textarea #myTextarea
                class="scrollbar-none box-border resize-none flex-1 min-w-0 bg-transparent focus:outline-hidden text-base leading-6"
                [ngClass]="canSend ? 'text-gray-900 dark:text-dark-text-primary' : 'text-gray-400 dark:text-dark-text-muted cursor-not-allowed'"
                [placeholder]="canSend ? 'Message...' : 'Read-only mode'"
                [disabled]="!canSend"
                id="my-textarea"
                [(ngModel)]="promptText"
                name="promptText"
                (input)="adjustHeight($event)"
                (focus)="onTextareaFocus()"
                (keydown.enter)="onKeyDownSendChatMessage($event)"
      ></textarea>
      <!-- FIN-0106: 36px circular send button (WhatsApp-like compact) with 120Hz press animation -->
      <!-- FIN-0108: Dark mode uses desaturated brand color -->
      <button
        class="select-none flex-shrink-0 w-9 h-9 self-end flex items-center justify-center rounded-full transition-all duration-fast ease-snap active:scale-95 will-change-transform"
        [ngClass]="{
          'bg-brand dark:bg-dark-brand hover:bg-brand-600 dark:hover:bg-dark-brand-dim shadow-xs': promptText.trim().length > 0 && canSend,
          'bg-gray-200 dark:bg-dark-surface': promptText.trim().length === 0 || !canSend,
          'hover:bg-gray-300 dark:hover:bg-dark-border-light': promptText.trim().length === 0 && canSend,
          'cursor-not-allowed': !canSend,
          'cursor-pointer': canSend
        }"
        [disabled]="!canSend"
        (click)="onButtonPressSendChatMessage($event)">
        <!-- Arrow up icon (WhatsApp style) -->
        <svg class="w-4.5 h-4.5 transition-colors duration-instant"
             [ngClass]="{
               'text-white': promptText.trim().length > 0 && canSend,
               'text-gray-400 dark:text-dark-text-tertiary': promptText.trim().length === 0 || !canSend
             }"
             viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 19V5M5 12l7-7 7 7"/>
        </svg>
      </button>
    </div>
  </div>
</div>
